<div class="flex-fill d-flex flex-column">
    <div class="card image-screen-collapse-horizontal">
        <div class="card-body">
            <dx-form *ngIf="filter" [formData]="filter">
                <dxi-item *ngIf="mode !== 'PackingSlip'" itemType="group">
                    <dxi-item [label]="{ text: 'Dealer' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="filter.dealerId"
                                [items]="dealers"
                                valueExpr="id"
                                displayExpr="companyName"
                                searchEnabled="true"
                                showClearButton="true"
                                (onValueChanged)="onDealerChanges($event)"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item
                        *ngIf="mode === 'Invoice'"
                        dataField="subItemId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Invoice' }"
                        [editorOptions]="{ items: subItems, valueExpr: 'id', displayExpr: 'invoiceNumber', onValueChanged: onSubItemChange }"
                    ></dxi-item>
                    <dxi-item
                        *ngIf="mode === 'SalesOrder'"
                        dataField="subItemId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Sales Order' }"
                        [editorOptions]="{ items: subItems, valueExpr: 'id', displayExpr: 'invoiceNumber', onValueChanged: onSubItemChange }"
                    ></dxi-item>
                </dxi-item>

                <dxi-item *ngIf="mode === 'PackingSlip'" itemType="group">
                    <dxi-item>
                        <div *dxTemplate>
                            <div class="d-flex">
                                <label class="me-2">Pack Slip #</label>
                                <dx-number-box [(value)]="filter.packingSlipNumber" [editorOptions]="{ step: 0 }"></dx-number-box>
                                <button class="btn btn-sm btn-success ms-3" (click)="search()">Search</button>
                            </div>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group">
                    <dxi-item>
                        <div *dxTemplate>
                            <div class="btn-toolbar justify-content-start align-items-center mt-3">
                                <button class="btn btn-primary"accesskey="s" (click)="takePicture()" [disabled]="!canAddPicture" >Take Picture</button>
                                <button class="btn btn-primary ms-2"accesskey="s" (click)="takePicture(true)" [disabled]="!canAddPicture" >Choose Picture</button>
                                <button (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
                            </div>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item>
                    <div *dxTemplate>
                        <div *ngIf="!!packSlip && orderLineDetails.length > 0">
                            OrderLineDetails
                            <table class="table mt-3">
                                <thead>
                                    <tr>
                                        <th>Qty</th>
                                        <th>Part#</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let data of orderLineDetails; let i = index" [ngClass]="{ 'group-start': isGroupStart(data, i) }">
                                        <td class="col-xs-5">{{ data.quantity }}</td>
                                        <td>
                                            <div
                                                class="parent-part-number"
                                                *ngIf="data.orderLine.partId && !data.orderLine.parentLineId && !data.orderLine.isReplacement"
                                            >
                                                {{ data.orderLine.partNumber }}
                                            </div>
                                            <div class="replacement-part-number" *ngIf="data.orderLine.isReplacement">{{ data.orderLine.partNumber }}</div>
                                            <div class="misc-part-number" *ngIf="!data.orderLine.partId && !data.orderLine.isReplacement">{{ data.orderLine.partNumber }}</div>
                                            <div class="option-part-number" *ngIf="data.orderLine.parentLineId">{{ data.orderLine.partNumber }}</div>
                                        </td>
                                        <td class="col-xs-5">{{ data.orderLine.description }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </dxi-item>

                <dxi-item itemType="group" caption="Attachments">
                    <dxi-item>
                        <div *dxTemplate>
                            <div class="images-container">
                                <div class="image-box" *ngFor="let photo of photos">
                                    <a class="image-remove" title="remove" (click)="removePhoto($event, photo)" *ngIf="photo.userCanDelete">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </a>
                                    <img [src]="photo.filename" (click)="openPhoto(photo)" />
                                </div>
                            </div>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
